(function () {
  function init(root) {
    if (!root || root.dataset.fcInit === 'true') return;
    root.dataset.fcInit = 'true';

    var cfgEl = root.querySelector('[data-fc-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    var variants = cfg.variants || [];
    var moneyFmt = cfg.moneyFormat || '${{amount}}';
    var discLife = cfg.discLife > 0 ? cfg.discLife : 100;
    var kitPrice = cfg.kitPrice || (variants[0] && variants[0].price) || 0;
    var roiDefaults = cfg.roiDefaults || { recesses: 10, rate: 70, old: 25, kit: 1 };

    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function money(cents) {
      var amount = (cents / 100);
      var withCents = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      var noCents = Math.round(amount).toString().replace(/\d(?=(\d{3})+$)/g, '$&,');
      return moneyFmt
        .replace('{{amount}}', withCents)
        .replace('{{amount_with_comma_separator}}', withCents.replace('.', ','))
        .replace('{{amount_no_decimals}}', noCents)
        .replace('{{amount_no_decimals_with_comma_separator}}', noCents);
    }

    var state = {
      variantIndex: Math.max(0, variants.findIndex(function (v) { return v.id === cfg.selectedId; })),
      qty: 1,
      roi: {
        recesses: roiDefaults.recesses,
        rate: roiDefaults.rate,
        old: roiDefaults.old,
        kit: roiDefaults.kit
      }
    };
    if (state.variantIndex < 0) state.variantIndex = 0;

    function curVariant() { return variants[state.variantIndex] || variants[0] || {}; }

    /* ---------- TOAST ---------- */
    var toastEl = root.querySelector('[data-fc-toast]');
    var toastMsg = root.querySelector('[data-fc-toast-msg]');
    var toastTimer;
    function toast(msg) {
      if (!toastEl) return;
      if (toastMsg) toastMsg.textContent = msg;
      toastEl.classList.add('is-visible');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
    }

    /* ---------- VARIANT ---------- */
    var varBtns = Array.prototype.slice.call(root.querySelectorAll('[data-fc-var]'));
    function selectByIndex(i, silent) {
      if (i < 0 || i >= variants.length) return;
      state.variantIndex = i;
      render();
      if (silent) return;
      var picked = variants[i];
      if (picked && picked.id) {
        document.dispatchEvent(new CustomEvent('fc:variant', { detail: { id: picked.id, from: root } }));
      }
    }
    varBtns.forEach(function (el) {
      el.addEventListener('click', function () {
        selectByIndex(parseInt(el.getAttribute('data-fc-var'), 10));
      });
    });

    document.addEventListener('fc:variant', function (e) {
      if (!e.detail || e.detail.from === root) return;
      for (var k = 0; k < variants.length; k++) {
        if (variants[k].id === e.detail.id) {
          if (k !== state.variantIndex) selectByIndex(k, true);
          return;
        }
      }
    });

    /* ---------- QTY ---------- */
    var qtyVals = Array.prototype.slice.call(root.querySelectorAll('[data-fc-qty-val]'));
    root.querySelectorAll('[data-fc-qty-dec]').forEach(function (b) {
      b.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); render(); });
    });
    root.querySelectorAll('[data-fc-qty-inc]').forEach(function (b) {
      b.addEventListener('click', function () { state.qty = Math.min(99, state.qty + 1); render(); });
    });

    /* ---------- GALLERY ---------- */
    var mainImg = root.querySelector('[data-fc-main-img]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-fc-thumb]'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-fc-thumb-src');
        var alt = t.getAttribute('data-fc-thumb-alt') || '';
        if (mainImg && src) { mainImg.src = src; mainImg.alt = alt; }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    /* ---------- CART HELPERS ---------- */
    function afterAdd(redirect) {
      fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true, detail: { baseEvent: 'fc:add', cart: cart }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (redirect) { window.location.href = routeRoot + 'cart'; return; }
          var drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer, .cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show();
          else if (drawer && typeof drawer.open === 'function') drawer.open();
          else document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        })
        .catch(function () {});
    }
    function postItems(items, onDone) {
      return fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (res) {
          if (!r.ok) { toast(res.description || res.message || 'Sorry, that could not be added to your cart.'); throw res; }
          if (onDone) onDone(res);
          return res;
        });
      });
    }

    // The ROI panel's button is sentence case, so an all-caps label is
    // softened for it rather than forcing two settings on the merchant.
    function sentence(t) {
      if (!t) return t;
      var up = t.replace(/[^A-Za-z]/g, '');
      if (up && up === up.toUpperCase()) return t.charAt(0) + t.slice(1).toLowerCase();
      return t;
    }

    /* ---------- ADD TO CART ---------- */
    var atcBtns = Array.prototype.slice.call(root.querySelectorAll('[data-fc-atc]'));
    function addToCart() {
      var v = curVariant();
      if (!v.id || v.available === false) return;
      atcBtns.forEach(function (b) { b.disabled = true; });
      postItems([{ id: v.id, quantity: state.qty }], function () {
        atcBtns.forEach(function (b) {
          b.classList.add('is-added');
          var lbl = b.querySelector('[data-fc-atc-label]');
          if (lbl) { b.dataset.fcLabel = lbl.textContent; lbl.textContent = (cfg.addedLabel || 'ADDED') + ' ✓'; }
        });
        toast(state.qty + ' × ' + cfg.title + ' (' + (v.shortName || v.title) + ') added to cart');
        afterAdd(cfg.redirect === 'cart');
        setTimeout(function () {
          atcBtns.forEach(function (b) {
            b.classList.remove('is-added');
            var lbl = b.querySelector('[data-fc-atc-label]');
            if (lbl) lbl.textContent = b.dataset.fcLabel || cfg.atcLabel || 'ADD TO CART';
          });
        }, 2200);
      }).catch(function () {}).finally(function () {
        atcBtns.forEach(function (b) { b.disabled = false; });
      });
    }
    atcBtns.forEach(function (b) { b.addEventListener('click', addToCart); });

    /* ---------- REPLACEMENT DISC (single add) ---------- */
    var discBtn = root.querySelector('[data-fc-addone]');
    if (discBtn) {
      discBtn.addEventListener('click', function () {
        var vid = parseInt(discBtn.getAttribute('data-fc-addone-variant'), 10);
        if (!vid) {
          var url = discBtn.getAttribute('data-fc-addone-url');
          if (url) window.location.href = url;
          return;
        }
        discBtn.disabled = true;
        postItems([{ id: vid, quantity: 1 }], function () {
          toast('Replacement recess disc added to cart');
          afterAdd(false);
        }).catch(function () {}).finally(function () { discBtn.disabled = false; });
      });
    }

    var replSelect = root.querySelector('[data-fc-repl-select]');
    if (replSelect && discBtn) {
      var replPrice = root.querySelector('[data-fc-repl-price]');
      replSelect.addEventListener('change', function () {
        var opt = replSelect.options[replSelect.selectedIndex];
        if (!opt) return;
        discBtn.setAttribute('data-fc-addone-variant', opt.value);
        if (replPrice) replPrice.textContent = opt.getAttribute('data-price');
      });
    }

    /* ---------- ADD-ONS KIT ---------- */
    var addonEls = Array.prototype.slice.call(root.querySelectorAll('[data-fc-addon]'));
    var kitTotalEl = root.querySelector('[data-fc-kit-total]');
    var kitCountEl = root.querySelector('[data-fc-kit-count]');
    var kitBtn = root.querySelector('[data-fc-kit-add]');

    function updateKit() {
      var total = 0, count = 0;
      addonEls.forEach(function (el) {
        if (el.classList.contains('is-checked')) {
          total += parseInt(el.getAttribute('data-fc-addon-price'), 10) || 0;
          count += 1;
        }
      });
      if (kitTotalEl) kitTotalEl.textContent = money(total);
      if (kitCountEl) kitCountEl.textContent = count + (count === 1 ? ' item' : ' items');
      if (kitBtn) kitBtn.disabled = count === 0;
    }
    addonEls.forEach(function (el) {
      if (!el.getAttribute('data-fc-addon-variant')) { el.style.display = 'none'; return; }
      el.addEventListener('click', function () { el.classList.toggle('is-checked'); updateKit(); });
    });
    if (kitBtn) {
      kitBtn.addEventListener('click', function () {
        var items = [];
        addonEls.forEach(function (el) {
          if (el.classList.contains('is-checked')) {
            var vid = parseInt(el.getAttribute('data-fc-addon-variant'), 10);
            if (vid) items.push({ id: vid, quantity: 1 });
          }
        });
        if (!items.length) return;
        kitBtn.disabled = true;
        postItems(items, function () {
          toast(items.length + (items.length === 1 ? ' item' : ' items') + ' added to your setup');
          afterAdd(false);
        }).catch(function () {}).finally(function () { kitBtn.disabled = false; });
      });
    }
    updateKit();

    /* ---------- ROI CALCULATOR ---------- */
    var roiInputs = Array.prototype.slice.call(root.querySelectorAll('[data-fc-roi]'));
    roiInputs.forEach(function (inp) {
      inp.addEventListener('input', function () {
        var key = inp.getAttribute('data-fc-roi');
        state.roi[key] = parseInt(inp.value, 10) || 0;
        renderRoi();
      });
    });

    function fmtHrs(h) { return (Math.round(h * 10) / 10) + ' hrs'; }
    function money0(cents) {
      var noCents = Math.round(cents / 100).toString().replace(/\d(?=(\d{3})+$)/g, '$&,');
      return moneyFmt
        .replace('{{amount}}', noCents + '.00')
        .replace('{{amount_with_comma_separator}}', noCents + ',00')
        .replace('{{amount_no_decimals}}', noCents)
        .replace('{{amount_no_decimals_with_comma_separator}}', noCents);
    }

    function setText(sel, txt) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
    }

    function renderRoi() {
      var r = state.roi;
      var v = curVariant();
      var savedMin = Math.max(0, r.old - r.kit);
      var savePerRecess = r.rate * (savedMin / 60);
      var weekly = savePerRecess * r.recesses;
      var monthly = weekly * 4;
      var hoursWeek = r.recesses * savedMin / 60;
      var hoursMonth = hoursWeek * 4;
      var costPerRecess = (kitPrice / 100) / discLife;
      var paybackRecesses = savePerRecess > 0 ? Math.ceil((v.price / 100) / savePerRecess) : 0;
      var paybackWeeks = (savePerRecess > 0 && r.recesses > 0) ? (paybackRecesses / r.recesses) : 0;
      var paybackTxt = paybackWeeks <= 1 ? 'under a week' : ('about ' + (Math.round(paybackWeeks * 10) / 10) + ' weeks');

      setText('[data-fc-roi-recesses-val]', r.recesses);
      setText('[data-fc-roi-rate-val]', money0(r.rate * 100) + '/hr');
      setText('[data-fc-roi-old-val]', r.old + ' min');
      setText('[data-fc-roi-kit-val]', r.kit + ' min');
      setText('[data-fc-roi-saved]', savedMin);
      setText('[data-fc-roi-rate-inline]', money0(r.rate * 100));
      setText('[data-fc-roi-recesses-inline]', r.recesses);

      setText('[data-fc-roi-save]', '$' + savePerRecess.toFixed(2));
      setText('[data-fc-roi-weekly]', money0(weekly * 100));
      setText('[data-fc-roi-monthly]', money0(monthly * 100));
      setText('[data-fc-roi-hours-week]', fmtHrs(hoursWeek));
      setText('[data-fc-roi-hours-month]', fmtHrs(hoursMonth));
      setText('[data-fc-roi-cost]', '$' + costPerRecess.toFixed(2));
      setText('[data-fc-roi-payback-recesses]', paybackRecesses);
      setText('[data-fc-roi-payback-weeks]', paybackTxt);
    }

    /* ---------- STICKY BAR ---------- */
    var sticky = root.querySelector('[data-fc-sticky]');
    if (sticky) {
      var footerVisible = false;
      var onScroll = function () {
        var past = (window.scrollY || window.pageYOffset || 0) > 600;
        if (past && !footerVisible) sticky.classList.add('is-visible');
        else sticky.classList.remove('is-visible');
      };
      var footer = document.querySelector('.shopify-section--footer, footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          onScroll();
        }, { rootMargin: '0px 0px 80px 0px' }).observe(footer);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---------- WHAT'S INCLUDED GRID ---------- */
    function syncInclGrid() {
      var grid = root.querySelector('[data-fc-incl-grid]');
      if (!grid) return;
      var shown = 0;
      grid.querySelectorAll('.fc-incl-card').forEach(function (c) { if (!c.hidden) shown++; });
      if (!shown) return;
      var max = parseInt(grid.getAttribute('data-fc-incl-max'), 10) || shown;
      var cols = Math.min(shown, max);
      grid.setAttribute('data-fc-cols', cols);
      grid.style.setProperty('--fc-incl-cols', cols);
    }

    /* ---------- RENDER ---------- */
    function render() {
      var v = curVariant();
      var i = state.variantIndex;

      varBtns.forEach(function (el) { el.classList.toggle('is-active', parseInt(el.getAttribute('data-fc-var'), 10) === i); });
      qtyVals.forEach(function (el) { el.textContent = state.qty; });

      setText('[data-fc-cur-short]', v.shortName || v.title || '');
      setText('[data-fc-cur-price]', money(v.price || 0));

      root.querySelectorAll('[data-fc-cur-was]').forEach(function (el) {
        if (v.compareAt && v.compareAt > v.price) { el.textContent = money(v.compareAt); el.style.display = ''; }
        else el.style.display = 'none';
      });
      root.querySelectorAll('[data-fc-cur-save]').forEach(function (el) {
        if (v.compareAt && v.compareAt > v.price) { el.textContent = 'SAVE ' + money(v.compareAt - v.price); el.style.display = ''; }
        else el.style.display = 'none';
      });
      setText('[data-fc-cur-quarter]', money(Math.round((v.price || 0) / 4)));
      setText('[data-fc-cur-exgst]', money(Math.round((v.price || 0) / 1.1)));
      setText('[data-fc-line-total]', money((v.price || 0) * state.qty));

      var grinderLine = (v.tagStyle === 'included') ? (cfg.grinderIncluded || '') : (cfg.grinderExcluded || '');
      var grinderShort = (v.tagStyle === 'included')
        ? (cfg.stickyIncluded || 'Grinder included')
        : (cfg.stickyExcluded || 'Grinder not included');
      var glEl = root.querySelector('[data-fc-grinder-line]');
      if (glEl && grinderLine) glEl.textContent = grinderLine;
      setText('[data-fc-grinder-short]', grinderShort);

      var isIncluded = (v.tagStyle === 'included');

      var leadEl = root.querySelector('[data-fc-grinder-lead]');
      var leadTxt = isIncluded ? (cfg.grinderLeadIncluded || '') : (cfg.grinderLeadExcluded || '');
      if (leadEl && leadTxt) leadEl.textContent = leadTxt;

      if (cfg.grinderIncluded || cfg.grinderExcluded || cfg.grinderLeadIncluded) {
        var noteEl = root.querySelector('[data-fc-grinder-note]');
        if (noteEl) noteEl.hidden = !(leadTxt || grinderLine);
        var iconEl = root.querySelector('[data-fc-grinder-icon]');
        if (iconEl) iconEl.textContent = isIncluded ? '✓' : '!';
      }

      root.querySelectorAll('[data-fc-when]').forEach(function (el) {
        var want = el.getAttribute('data-fc-when');
        el.hidden = (want === 'included') ? !isIncluded : (want === 'excluded' ? isIncluded : false);
      });

      syncInclGrid();

      var avail = v.available !== false;
      root.querySelectorAll('[data-fc-stock]').forEach(function (el) {
        el.classList.toggle('is-oos', !avail);
        var lbl = el.querySelector('[data-fc-stock-lbl]');
        if (lbl) lbl.textContent = avail ? (cfg.inStockLabel || 'In stock') : (cfg.outOfStockLabel || 'Out of stock');
      });
      atcBtns.forEach(function (b) {
        var lbl = b.querySelector('[data-fc-atc-label]');
        var isRoi = b.classList.contains('fc-roi-atc');
        b.disabled = !avail;
        if (lbl && !b.classList.contains('is-added')) {
          var add = cfg.atcLabel || 'ADD TO CART';
          var out = cfg.soldoutLabel || 'SOLD OUT';
          if (isRoi) { add = sentence(add); out = sentence(out); }
          lbl.textContent = avail ? add : out;
        }
      });

      renderRoi();
    }
    render();
  }

  function boot() {
    document.querySelectorAll('[data-fc-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-fc-pdp]');
    if (r) init(r);
  });
})();
